module.exports = __webpack_public_path__ + "img/swiper-3.1cf33461.jpg";